// extracted by mini-css-extract-plugin
export default {"wrap":"Ap-z","logoContainer":"Bp-z","brandImg":"Cp-z","logoImg":"Dp-z","logoButton":"Ep-z"};